import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MazPhoneNumberInput = _resolveComponent("MazPhoneNumberInput")!

  return (_openBlock(), _createBlock(_component_MazPhoneNumberInput, {
    modelValue: _ctx.localModel,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localModel) = $event)),
    "preferred-countries": ['FI','SE', 'NO'],
    "no-use-browser-locale": "false",
    onCountryCode: _ctx.updateCountryCode,
    onUpdate: _ctx.updateIsValidPhone
  }, null, 8, ["modelValue", "onCountryCode", "onUpdate"]))
}